import { useCallback } from "react";
import { useDispatch } from "react-redux";

import * as auth from "app/modules/Auth/_redux/authRedux";

type CaptureOab = () => Promise<unknown>;

export function useRegisterOab() {
  const dispatch = useDispatch();

  return useCallback(
    async (captureOab: CaptureOab) => {
      await captureOab();
      dispatch(auth.actions.requestUser());
    },
    [dispatch],
  );
}
